
export const USER_DETAIL="userdetail";
export const NOTIFYSUCC="notifysuccess";
export const NOTIFYCLEAR="notifyclear";
export const NOTIFYERROR="notifyserror";
export const TEMPORARY="temporary";
export const TEMPORARYCLEAR="temporaryclear";
export const USERS="users";
export const PRE_REGISTER="pre-register";
export const GETROOM="getroon";
export const BOOKROOM = "bookroom";
export const ALLRATINGS="allratings";
export const ROOMTYPES="roomtypes";
export const ALLORDERSD="allordersd";
export const GETROOMS="getrooms";
export const ADDROOM="Addroom";
export const ORDERDETAIL="OrderDetail";
export const ALLORDERMEETING="ALLORDERMEETING"
export const CONFERENCEREVENUE="CONFERENCEREVENUE"
// export const API="https://rixoshotels.onrender.com";
export const API="http://localhost:3004/api";
// export const API="/api";


export const SEARCRESULTS="SEARCRESULTS";
export const YEARMONTHSTAT="YearMonthstat"
export const BOOKCONFERENCE="BookConference";
export const ADMIN_DETAIL="ADMIN_DETAIL"
export const ADMINACCOUNT="ADMINACCOUNTs"
export const CLIENT_AUTH_INIT="client_auth_id"
export const GOOGLE_AUTH_CLIENT_ID="983545037596-odvrq2n8lh6unrv9b47mmqk47uhe8lfh.apps.googleusercontent.com"
